import apiClient from './client'
import type { AnalysisPaper, CreatePaperDto, UpdatePaperDto } from '@/types/paper'

export const papersApi = {
  create: async (dto: CreatePaperDto): Promise<AnalysisPaper> => {
    const response = await apiClient.post('/papers', dto)
    return response.data?.data ?? response.data
  },

  list: async (options?: { scriptId?: string; limit?: number; offset?: number }): Promise<{ data: AnalysisPaper[]; total: number }> => {
    const params = new URLSearchParams()
    if (options?.scriptId) params.append('scriptId', options.scriptId)
    if (options?.limit != null) params.append('limit', String(options.limit))
    if (options?.offset != null) params.append('offset', String(options.offset))
    const response = await apiClient.get(`/papers?${params.toString()}`)
    const data = response.data?.data ?? response.data?.papers ?? []
    const total = response.data?.total ?? (Array.isArray(data) ? data.length : 0)
    return { data: Array.isArray(data) ? data : [], total }
  },

  get: async (id: string): Promise<AnalysisPaper> => {
    const response = await apiClient.get(`/papers/${id}`)
    return response.data?.data ?? response.data
  },

  update: async (id: string, dto: UpdatePaperDto): Promise<AnalysisPaper> => {
    const response = await apiClient.patch(`/papers/${id}`, dto)
    return response.data?.data ?? response.data
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/papers/${id}`)
  },
}
